import Vue, { VueConstructor } from 'vue';
import { CoreServiceAPI } from '@glittr/frontend-core/src/services/v1';
import generatedApi from './generated/generatedApi';

const loadApi = () => ({
  ...generatedApi(),

  // Add custom apis here
  // persons: { ...personsServices(Vue.$service) },
});

export default {
  install: (VuePlugin: VueConstructor, options: any) => {
    VuePlugin.$guards.waitForAppLoad().then(() => {
      const coreApi = VuePlugin.$service.v1.api as CoreServiceAPI;
      VuePlugin.$service.v1.api = { ...coreApi as any, ...loadApi() };
      VuePlugin.prototype.$service.api = Vue.$service.api;
    });
  },
};

type AppServiceType = ReturnType<typeof loadApi>;
declare module '@glittr/frontend-core/src/plugins/servicelayer/servicelayer' {
  interface ServiceAPI extends AppServiceType { }
}
